<template>
    <section>
        <LoadHero />
        <LoadCategory />
        <LoadCollection />
        <LoadProductDisplay />
        <LoadShorts />
        <LoadNews />
    </section>
</template>

<script setup lang="ts">
import LoadHero from './LoadHero.vue';
import LoadCategory from './LoadCategories.vue';
import LoadCollection from './LoadCollection.vue';
import LoadProductDisplay from './LoadProductDisplay.vue';
import LoadShorts from './LoadShorts.vue';
import LoadNews from './LoadNews.vue';
</script>
